// extracted by mini-css-extract-plugin
module.exports = {"root":"RangeFilterPopup_root__3SlUC","label":"RangeFilterPopup_label__1qjr3","labelSelected":"RangeFilterPopup_labelSelected__3t9BN"};